import { Component, inject } from '@angular/core';
import { Toast } from '../toast/toast';

@Component({
  selector: 'app-appointment-info',
  standalone: true,
  templateUrl: './appointment-info.html',
  styleUrl: './appointment-info.scss',
})
export class AppointmentInfo {
  protected readonly toast = inject(Toast);
}
